import { render, staticRenderFns } from "./project-automation-panel.vue?vue&type=template&id=5d34359c&scoped=true"
import script from "./project-automation-panel.vue?vue&type=script&lang=js"
export * from "./project-automation-panel.vue?vue&type=script&lang=js"
import style0 from "./project-automation-panel.vue?vue&type=style&index=0&id=5d34359c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!D:\\wwwroot\\deepcityAI\\user-client-pc\\user-client-common-pc\\node_modules\\@vue\\vue-loader-v15\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d34359c",
  null
  
)

export default component.exports